import React, { useState } from 'react'

interface ImageWithSkeletonProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  containerClassName?: string
  showErrorFallback?: boolean
}

export const ImageWithSkeleton: React.FC<ImageWithSkeletonProps> = ({
  src,
  alt,
  className,
  containerClassName,
  showErrorFallback = true,
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [hasError, setHasError] = useState(false)

  const handleError = () => {
    setHasError(true)
    setIsLoaded(true)
  }

  if (hasError && showErrorFallback) {
    return (
      <div
        className={`flex items-center justify-center bg-gray-200 ${containerClassName}`}
        style={{ backgroundColor: 'var(--bg-secondary)' }}
      >
        <span
          className='text-sm'
          style={{ color: 'var(--text-tertiary)' }}
        >
          تصویر در دسترس نیست
        </span>
      </div>
    )
  }

  return (
    <div className={`relative ${containerClassName}`}>
      {!isLoaded && (
        <div
          className={`absolute inset-0 bg-gray-200 animate-pulse rounded-md`}
        />
      )}
      <img
        src={src}
        alt={alt}
        className={`transition-opacity duration-500 ${
          isLoaded ? 'opacity-100' : 'opacity-0'
        } ${className}`}
        onLoad={() => setIsLoaded(true)}
        onError={handleError}
        {...props}
      />
    </div>
  )
}
